<template>
  <div class="static-page">
    <main class="mx-auto max-w-screen-xl px-4 py-12">
      <div class="flex justify-center mt-24">
        <h1 class="gradient-title">{{ article.title }}</h1>
      </div>

      <article class="mt-16 mx-auto max-w-screen-lg">
        <VueMarkdownIt class="markdown-body" :source="article.markdown_content" />
      </article>
    </main>
  </div>
</template>

<script setup lang="ts">
  import { useHead } from '@unhead/vue'
  import { useStore } from '$/stores'
  import { VueMarkdownIt } from '@f3ve/vue-markdown-it'

  const store = useStore()

  const props = defineProps<{
    slug: string
  }>()

  const article = store.article(props.slug)

  useHead({
    title: `${article.title} | PicEditor.io`,
    meta: [
      {
        name: 'description',
        content: article.description,
      },
    ],
    link: [
      {
        rel: 'canonical',
        href: `/help/${article.slug}`,
      },
    ],
  })
</script>

<style scoped lang="scss">
  .markdown-body {
    background-color: white !important;
    padding: 1rem;
  }
</style>
